import ColourCount from './ColourCount';

function App() {
  return <ColourCount />;
}

export default App;